module.exports = __webpack_public_path__ + "assets/images/overview/hdb-overview-desktop.png?v=b69e232e";